import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    language: db.get('language')
  },
  mutations: {
    setLanguage (state, val) {
      val = val || 'zh-cn'
      db.save('language', val)
      state.language = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js